import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
	selector: 'recipe-badge',
	template: `<p [ngStyle]="{ 'background-color': color }">{{ title }}</p>`,
	styleUrls: ['./badge.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgStyle],
})
export class BadgeComponent {
	@Input() title: string;
	@HostBinding('attr.data-text')
	textColor: string;
	badgetColor = '#ffdd00'; // school-bus-yellow

	get color(): string {
		return this.badgetColor;
	}

	@Input() set color(value: string) {
		this.textColor = this.getContrastingTextColor(value);
		this.badgetColor = value;
	}
	getContrastingTextColor(backgroundColor = ''): 'dark' | 'light' {
		const justHex = backgroundColor.match(/^#([0-9a-f]{6})$/i)?.[1];
		// Default to dark since an invalid color will result in no bg color
		if (backgroundColor.length !== 7 || !justHex) {
			return 'dark';
		}

		const red = parseInt(justHex.substr(0, 2), 16);
		const green = parseInt(justHex.substr(2, 2), 16);
		const blue = parseInt(justHex.substr(4, 2), 16);

		// http://www.rampweb.com/toolbar/colorcontrast.html
		const brightness = Math.round(red * 299 + green * 587 + (blue * 114) / 1000);
		const lightColor = 225959; // Math.round((255 * 299) + (255 * 587) + (255 * 114) / 1000);
		if (brightness < lightColor / 2) {
			return 'light';
		}
		return 'dark';
	}
}
